import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

const keycodes = { space: 32, enter: 13 };

export default class extends Controller {
  visitDataUrl(event: Event) {
    const keyboardEvent = event as KeyboardEvent;
    const target = event.target as HTMLElement;
    if (
      event.type == "click" ||
      keyboardEvent.keyCode == keycodes.space ||
      keyboardEvent.keyCode == keycodes.enter
    ) {
      if ((target as HTMLAnchorElement).href) {
        return;
      }

      const dataUrl = target.closest("tr")?.dataset.url;
      const selection = window.getSelection()?.toString() ?? "";
      if (selection.length === 0 && dataUrl) {
        Turbo.visit(dataUrl);
      }
    }
  }
}
